"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).call(this, props));
    _this.inner = null;
    _this.outer = null;

    _this.setInnerRef = function (element) {
      _this.inner = element;
    };

    _this.setOuterRef = function (element) {
      _this.outer = element;
    }; // Bind class methods


    _this.handleTriggerClick = _this.handleTriggerClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Defaults the dropdown to be closed

    _this.state = {
      isClosed: !props.isOpen,
      shouldSwitchAutoOnNextCycle: false,
      height: props.isOpen ? 'auto' : 0,
      transition: props.isOpen ? 'none' : "height ".concat(props.transitionTime, "ms ").concat(props.easing),
      hasBeenOpened: props.isOpen,
      overflow: 'hidden',
      inTransition: false
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      if (prevProps.isOpen !== this.props.isOpen) {
        if (this.props.isOpen) {
          this.openCollapsible();
        } else {
          this.closeCollapsible();
        }
      }
    }
  }, {
    key: "closeCollapsible",
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.inner.offsetHeight,
        transition: "height ".concat(this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime, "ms ").concat(this.props.easing),
        inTransition: true
      });
    }
  }, {
    key: "openCollapsible",
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: "continueOpenCollapsible",
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.inner.offsetHeight,
        transition: "height ".concat(this.props.transitionTime, "ms ").concat(this.props.easing),
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick(event) {
      event.preventDefault();

      if (this.state.isClosed) {
        this.openCollapsible();
      } else {
        this.closeCollapsible();
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({
          height: 'auto',
          overflow: 'hidden',
          inTransition: false
        });
        this.props.onOpen();
      } else {
        this.setState({
          inTransition: false
        });
        this.props.onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };
      var openClass = this.state.isClosed ? 'is-closed' : 'is-open'; // If user wants different text when tray is open

      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger; // Don't render children until the first opening of the Collapsible
      // if lazy rendering is enabled

      var children = this.props.isLazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children; // Construct CSS classes strings

      var triggerClassString = "collapse__trigger ".concat(openClass, " ").concat(this.state.isClosed ? this.props.triggerClosedClassName : this.props.triggerOpenedClassName);
      var parentClassString = "collapse ".concat(this.state.isClosed ? this.props.collapsedClassName : this.props.openedClassName);
      return _react.default.createElement("div", {
        className: parentClassString.trim()
      }, _react.default.createElement("div", {
        role: "button",
        tabIndex: "0",
        className: triggerClassString.trim(),
        onClick: this.handleTriggerClick,
        onKeyPress: function onKeyPress(event) {
          var key = event.key;

          if (key === ' ' || key === 'Enter') {
            _this3.handleTriggerClick(event);
          }
        },
        "data-spec": "collapse-button"
      }, trigger), _react.default.createElement("div", {
        ref: this.setOuterRef,
        style: dropdownStyle,
        onTransitionEnd: this.handleTransitionEnd,
        "data-spec": "collapse-wrapper"
      }, _react.default.createElement("div", {
        ref: this.setInnerRef,
        className: "u-overflow-auto"
      }, children)));
    }
  }]);

  return Collapse;
}(_react.Component);

Collapse.propTypes = {
  /** Length of time for the collapse transition */
  transitionTime: _propTypes.default.number,

  /** Alternate length of time for the collapse transition when closing */
  transitionCloseTime: _propTypes.default.number,

  /** Name of the transision timing function to be used for the open/close transition */
  easing: _propTypes.default.string,

  /** Whether the collapsable area should default to being opened or closed */
  isOpen: _propTypes.default.bool,

  /** Prevent collapsable content from being rendered when collapse area closed */
  isLazyRender: _propTypes.default.bool,

  /** Custom class name to be applied to the collapse wrapper when opened */
  openedClassName: _propTypes.default.string,

  /** Custom class name to be applied to the collapse wrapper when collapsed */
  collapsedClassName: _propTypes.default.string,

  /** Custom class name to be applied to the trigger when closed */
  triggerClosedClassName: _propTypes.default.string,

  /** Custom class name to be applied to the trigger when opened */
  triggerOpenedClassName: _propTypes.default.string,

  /** String or element to be used as the collapsable area's trigger */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /** Alternate string or element to be used as the collapse trigger when open */
  triggerWhenOpen: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /** Content to be made collapsable */
  children: _propTypes.default.node,

  /** Function to be called when the collapsable area is opened */
  onOpen: _propTypes.default.func,

  /** Function to be called when the collapsable area is closed */
  onClose: _propTypes.default.func
};
Collapse.defaultProps = {
  transitionTime: 500,
  transitionCloseTime: null,
  easing: 'ease-out',
  isOpen: false,
  isLazyRender: false,
  openedClassName: '',
  collapsedClassName: '',
  triggerClosedClassName: '',
  triggerOpenedClassName: '',
  trigger: '',
  triggerWhenOpen: undefined,
  children: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};
var _default = Collapse;
exports.default = _default;